import { render, staticRenderFns } from "./SendPasswordEmail.vue?vue&type=template&id=46e406dc&"
import script from "./SendPasswordEmail.vue?vue&type=script&lang=js&"
export * from "./SendPasswordEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports